<template>
  <div v-if="!isEmpty(reviews)" :class="`${classVariableName}-mob-gallery-view-container`">
    <div :class="`${classVariableName}-mob-avg-viewall-container`">
      <div :class="`${classVariableName}-top-reviews-title`" :style="{margin: '0'}">Reviews with photos</div>
      <div :class="`${classVariableName}-avg-rating-knowmore`" @click="()=>openDetailedGallery()">
        View all
        <Arrow
          direction="right"
          v-if="imageCount !== 0"
        />
      </div>
    </div>
    <div style="overflow-x:auto; padding-left:16px;">
      <div :class="`${classVariableName}-mob-gallery-view-image-container`">
        <img @click="() => openImageReviewDetails(review)" v-for="review of reviews" :key="review.id"
          :class="`${classVariableName}-mob-gallery-view-image ${classVariableName}-cursor-pointer`" :src="review.image.lowResUrl" loading="lazy"
          alt="Review Image..." />
        <div @click="()=>openDetailedGallery()" v-if="detailedGalleryReviews.length > maxImagesCount"
          :class="`${classVariableName}-mob-gallery-view-image-more ${classVariableName}-cursor-pointer`">
          <div v-if="imageCount !== 0">+{{ imageCount - maxImagesCount }}</div>
          More
        </div>
      </div>
    </div>
    <GalleryDetailsModal v-if="detailedGallery && !detailedReview" :imageCount="imageCount"
      :reviews="detailedGalleryReviews" :product="product" :loading="loading" :onClose="()=>closePreviews()" :openImageReviewDetailsModal="(event) => {
        openReviewDetails(event);
      }" :getNextPage="getNextPage" />
    <ImageReviewModal v-if="detailedReview" :hasNext="hasNextReview" :hasPrev="hasPrevReview" :product="product"
      :currentIndex="imageCurrentIndex" :detailedGalleryFlow="detailedGallery" :openDetailedGallery="() => {
        detailedReview = false;
        detailedGallery = true;
      }" :onClose="()=>closePreviews()" :review="currentReviewDetails" :validationConfig="validationConfig" :vote="isEmpty(userCurrentReview) || userCurrentReview.id !== currentReviewDetails.id"
      :setAlert="(message, type) => setAlert(message, type)" :getReview="(event) => {
        getReviewByIndex(event);
        imageCurrentIndex=0;
      }" />
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import { isEmpty, classVariableName, RATING_KEYS,emitEvent, getEventData } from "../../utils";
import customerServices from "../../services/customer-review.js";
import GalleryDetailsModal from "./GalleryDetailsModal.vue";
import Arrow from "../common/Arrow.vue";
import ImageReviewModal from "./ImageReviewModal.vue";
import CUSTOM_EVENTS from "../../constants";

export default defineComponent({
  name: "galleryViewComponent",
  setup() {},
  components: {
    GalleryDetailsModal,
    ImageReviewModal,
    Arrow,
  },
  data() {
    return {
      loading: false,
      reviews: null,
      detailedGalleryReviews: null,
      detailedGallery: false,
      detailedReview: false,
      ratingKeys: RATING_KEYS,
      pageNo: 0,
      pageSize: 10,
      hasNext: false,
      currentReviewDetails: null,
      classVariableName: classVariableName,
      reviewMap: null,
      reviewIds: null,
      hasNextReview: false,
      hasPrevReview: false,
      imageCurrentIndex: 0,
    };
  },
  props: {
    product: Object,
    productId: String,
    imageCount: Number,
    validationConfig: Object,
    userCurrentReview: Object,
    setAlert: Function,
  },
  mounted() {
    this.getImageReviews();
  },
  computed: {
    maxImagesCount() {
      if (window.innerWidth > 1024) { return 7; }
      if (window.innerWidth > 768) { return 5; }
      if (window.innerWidth > 425) { return 3; }
      if (window.innerWidth > 375 ) { return 5; }
      return 3;
    }
  },
  methods: {
    isEmpty(val) {
      return isEmpty(val);
    },
    async closePreviews() {
      emitEvent(CUSTOM_EVENTS.REVIEWS_WITH_IMAGES_CLOSE_PREVIEW, getEventData(!isEmpty(Object.keys(window.FPI.state.user._data)), 'image_gallery', this.product, this.userCurrentReview));
      this.detailedGallery = false;
      this.detailedReview = false;
    },
    async openDetailedGallery() {
      this.detailedGallery = true;
      emitEvent(CUSTOM_EVENTS.REVIEWS_WITH_IMAGES_VIEW_ALL, getEventData(!isEmpty(Object.keys(window.FPI.state.user._data)), 'PDP', this.product, this.userCurrentReview));
    },
    async getImageReviews(reset = true) {
      return await customerServices
        .getProductReviewImages({
          productId: this.productId,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          sortBy: "MOST_RECENT",
        })
        .then((data) => {
          let res = data.data;
          if (res.resultInfo.status === "SUCCESS") {
            if (reset) {
              this.detailedGalleryReviews = [];
              this.reviewMap = {};
              this.reviewIds = [];
            }
            if (res.data.reviews.length !== 0) {
              this.detailedGalleryReviews = [
                ...this.detailedGalleryReviews,
                ...res.data.reviews,
              ];
              if (isEmpty(this.reviews)) {
                this.reviews = this.detailedGalleryReviews.slice(0, this.maxImagesCount);
              }
              this.populateReviewMap();
            }
            this.hasNext = res.data.page.hasNext;
            this.loading = false;
          }
        });
    },
    async openImageReviewDetails(review) {
      await this.openReviewDetails(review);
    },
    async openReviewDetails(imageReview) {
      emitEvent(CUSTOM_EVENTS.REVIEWS_WITH_IMAGES_CLICK_ON_PAGE, getEventData(!isEmpty(Object.keys(window.FPI.state.user._data)), 'image_gallery', this.product, imageReview));
      this.detailedReview = true;
      this.currentReviewDetails = this.reviewMap[`${imageReview.id}`];
      let index = this.reviewIds.indexOf(imageReview.id);
      this.populatePaginatedCriteria(index);

      for (let i = 0; i < this.currentReviewDetails.imageList.length; i++) {
        let obj = { ...this.currentReviewDetails.imageList[i] };
        if (obj.id === imageReview.image.id) {
          this.imageCurrentIndex = i;
          return;
        }
      }
    },

    async getReviewByIndex(index) {
      emitEvent(CUSTOM_EVENTS.REVIEWS_WITH_IMAGES_PREVIEW_NEXT, getEventData(!isEmpty(Object.keys(window.FPI.state.user._data)), 'image_gallery', this.product, this.userCurrentReview)); 
      this.currentReviewDetails = this.reviewMap[`${this.reviewIds[index]}`];
      this.populatePaginatedCriteria(index);
    },

    async populatePaginatedCriteria(index) {
      this.currentReviewDetails.index = index;
      if (index > 0) {
        this.hasPrevReview = true;
      } else {
        this.hasPrevReview = false;
      }
      if (index < this.reviewIds.length - 1) {
        this.hasNextReview = true;
      } else {
        this.hasNextReview = false;
      }
    },

    async getNextPage() {
      if (this.hasNext) {
        this.loading = true;
        this.pageNo = this.pageNo + 1;
        return await this.getImageReviews(false);
      }
    },

    async populateReviewMap() {
      this.detailedGalleryReviews.forEach((review) => {
        if (isEmpty(this.reviewMap[`${review.id}`])) {
          this.reviewIds.push(review.id);
          this.reviewMap[`${review.id}`] = review;
        }
      });
    },
  },
});
</script>
<style lang="scss" scoped>
@import "../../assets/Mob.scss";
</style>
